import React from 'react';
import Styled from './OverlayLoader.style';
import Loader from '../../components/Loader';

interface OverlayLoaderProps {
  loading: boolean;
}

const OverlayLoader: React.FC<OverlayLoaderProps> = (props) => {
  const { loading } = props;

  if (!loading) {
    return null;
  }
  return (
    <Styled.Overlay>
      <Loader size={4} />
    </Styled.Overlay>
  );
};

export default OverlayLoader;
